import NiceModal from '@ebay/nice-modal-react';

import React, { useEffect, useState } from 'react';

import * as F from 'components/form/FormLayout.styled';
import Modal from 'components/global/Modal';
import NoRecordsFound from 'components/global/NoRecordsFound';
import Typography from 'components/global/Typography';
import { ModalContent, ModalTitle } from 'components/global/styled/Modal.styled';
import Table from 'components/table/Table';

const GeneratedPickupOrderModal = NiceModal.create(({ orders }) => {
	const [data, setData] = useState([]);

	useEffect(() => {
		if (orders.length > 0) {
			setData([...orders]);
		}
	}, []);

	return (
		<Modal maxWidth="no-max-width" fullwidth className="modal-pcPriceMatcher">
			<ModalTitle>
				<Typography variant="p1">GeneratedPickupOrderModal</Typography>
			</ModalTitle>
			<F.TabsFormContainer>
				<ModalContent style={{ width: '100%' }}>
					<GeneratedPickupOrderTable data={data} />
				</ModalContent>
			</F.TabsFormContainer>
		</Modal>
	);
});

export default GeneratedPickupOrderModal;

const GeneratedPickupOrderTable = ({ data, isLoading }) => {
	const columns = React.useMemo(
		() => [
			{
				header: 'orderNumber',
				accessorKey: 'Id'
			},
			{
				header: 'success',
				accessorKey: 'success',
				renderCell: ({ row }) => <>{row.original.status ? 'yes' : 'no'}</>,
				show: true
			},
			{
				header: 'companyId',
				accessorKey: 'companyId'
			},
			{
				header: 'errorMessage',
				accessorKey: 'errorMessage'
			},
			{
				header: 'dcSettingsId',
				accessorKey: 'dcSettingsId'
			},
			{
				header: 'pickingType',
				accessorKey: 'pickingType'
			},
			{
				header: 'pickupCutoffTime',
				accessorKey: 'pickupCutoffTime'
			}
		],
		[]
	);

	return (
		<Table
			columns={columns}
			data={data}
			loading={isLoading}
			noRecordsFound={
				<NoRecordsFound lottieName="no-items" height="10rem" title="noItems" subTitle="noItemsSubtitle" />
			}
		/>
	);
};
